import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { AbstractDialogManagerProperties } from "@lib/titan2/dist/game/view/properties/AbstractDialogManagerProperties";
import { MessageDialogProperties } from "../common/MessageDialogProperties";
import { PromptDialogProperties } from "../common/PromptDialogProperties";
import { RealityCheckDialogProperties, RealityCheckNoOptionsDialogProperties } from "../common/RealityCheckDialogProperties";
import { ResponsibleGamingDialogProperties } from "../common/ResponsibleGamingDialogProperties";
/**
 * DialogManagerTabletProperties.ts
 */
export class DialogManagerLandscapeProperties extends AbstractDialogManagerProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.72, false);
        this.messageDialogProperties = new MessageDialogProperties();
        this.promptDialogProperties = new PromptDialogProperties();
        this.realityCheckDialogProperties = new RealityCheckDialogProperties();
        this.realityCheckNoOptionsDialogProperties = new RealityCheckNoOptionsDialogProperties();
        this.responsibleGamingDialogProperties = new ResponsibleGamingDialogProperties();
    }
}
